<template>
  <section class="content">
    <h1>Overview</h1>
    <p>Welcome to the AAECOSYSTEM developer website.</p>

    <section class="cards d-flex">
      <div class="card mt-8" v-for="(doc, index) in docs" :key="index">
        <img :src="doc.logo" class="img" />
        <h2>{{ doc.name }}</h2>
        <p>{{ doc.description }}</p>
        <p>
          <router-link :to="getPushLink(doc)"
            >See {{ doc.name }}
            <v-icon color="blue" small>mdi-arrow-right</v-icon></router-link
          >
        </p>
        <div v-if="doc.name.includes('API')" class="chip">API</div>
      </div>
    </section>

    <section class="contact-us mt-4">
      <h1>Contact Us</h1>
      <p class="mt-2 ml-1">developer.support@assaabloy.com</p>
    </section>
  </section>
</template>

<script>
import config from '../config';
import util from '../util';

export default {
  data: () => {
    return {
      docs: null,
    };
  },
  created: async function () {
    await this.getDocs();
  },
  methods: {
    getDocs: async function () {
      const options = {
        method: 'GET',
        ...config.defaultFetchOptions,
      };
      const result = await util.fetch(`${this.$store.state.apiHost}/docs`, options);

      if (result.ok) {
        const docs = await result.json();
        this.docs = docs;
      } else {
        this.$store.commit('snackbar', {text: 'Failed to get docs.', color: 'error'});
      }
    },

    getPushLink: function (doc) {
      return doc.name.includes('API')
        ? { name: 'Documentation', params: { url: doc.url } }
        : doc.url;
    },
  },
};
</script>

<style lang="scss">
h1 {
  font-size: 36px;
  margin-bottom: 1rem;
}
h2 {
  margin-bottom: 1rem;
}

.cards {
  width: 100%;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-between;
  padding-bottom: 50px;

  .card {
    width: 30%;

    .chip {
      display: inline-block;
      padding: 4px 14px 4px 10px;
      border-radius: 1rem;
      background-color: #262626;
      color: #ffffff;
    }
    .img {
      width: 200px;
      margin-left: -20px;
      margin-bottom: -20px;
    }
  }
}

.contact-us {
  height: 258px;
}

@media only screen and (max-width: 600px) {
  .cards {
    display: flex;
    flex-direction: column;

    .card {
      width: 100%;
    }
  }
}
</style>